import {setStore, getStore, removeStore} from '@/utils/storage';
import cookie from "react-cookies";
import domain from '@/utils/domain';

export function isUserLogin() {
  let token=document.cookie.indexOf("token=");
  if(token == -1){
    return false;
  }
  return true;
}

